import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Box, Link, rem, Text } from '@bonusly/design-system';

import { FishBowl } from './components';
import { useSearchContext } from './context';

export const EmptyState: FC = () => {
	const { query } = useSearchContext();
	const { t } = useTranslation('navigation');

	return (
		<Box color="text.default" textAlign="center" py={6}>
			<Text fontWeight="bold" mb={6}>
				{t('search.empty_state_title')}
			</Text>

			<FishBowl height="auto" mb={4} width={rem(244)} />

			<Text fontSize="lg" fontWeight="normal">
				{t('search.empty_state_description')}
			</Text>

			<Text fontSize="lg" fontWeight="normal">
				<Trans t={t} i18nKey="search.empty_state_link">
					{/* NOTE: Translations here are just for guidance. The <Trans> component
          will properly format them with locale text */}
					If you're having trouble try searching our{' '}
					<Link href={`https://help.bonus.ly/en/?q=${query}`} target="_blank">
						help center
					</Link>
				</Trans>
			</Text>
		</Box>
	);
};
